import { NzMessageService, UploadFile } from 'ng-zorro-antd';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonsService } from '@core/service/commons.service';
import { LicenseGrantService } from './license-grant.service';

@Component({
  selector: 'app-license-grant',
  templateUrl: './license-grant.component.html',
  styleUrls: ["./license-grant.component.css"]
})
export class LicenseGrantComponent extends LicenseGrantService implements OnInit {

  //控制授权模块显示隐藏的变量
  model = false;
  //控制上传按钮的变量
  uploading = false;
  //上传的文件
  files: File[] = [];
  //转转转
  spin:boolean = false;

  //接受后端信息的实体类
  licenseInfo = {
    registCode:"",
    timeEnd:"",
    custom:"",
    modules:[]
  };

  //展示隐藏授权模块列表
  show(){
    if (this.licenseInfo.modules == null || this.licenseInfo.modules == []){
      this.commons.showInfoMessage("licenseGrant.tips.noModule")
    } else {
      this.model = !this.model;
    }
  }

  handleCancel(){
    this.model = false;
  }
  handleOk(){
    this.model = false;
  }

  //点击上传文件
  upload(){
   this.commons.showConfirm("licenseGrant.tips.uploadConfirm",()=>this.goUpload(),()=>this.uploadCensel());
  }

  //取消文件上传
  uploadCensel(){
    this.uploading = false;
  }

  //文件上传的具体操作
  goUpload(){
    this.uploading = true;
    this.changeLicense(this.files[0]).subscribe((data:any) => {
      if (data.code === 0){
        this.commons.showSuccessMessage("licenseGrant.tips.success");
        this.uploading = false;
        this.licenseInfo = {
          registCode:"",
          timeEnd:"",
          custom:"",
          modules:[]
        };
        this.ngOnInit();
        this.files = [];
      } else {
        this.files = [];
        this.commons.showErrorMessage("licenseGrant.tips.errorFile")
      }
    });
    this.uploading = false;
  }

  //文件上传时的钩子，每次选中文件后执行的方法
  beforeUpload= (file): boolean => {
    if(file != null && file.name != null && file.name != ""){
      let index = file.name.lastIndexOf(".");
      let suf = file.name.substring(index+1,file.name.length);
      if (suf != "key"){
        this.commons.showErrorMessage("licenseGrant.tips.error");
        return false;
      }
    }
    if (this.files.length == 0 ){
      this.files.push(file);
    }else{
      this.files.splice(0);
      this.files.push(file)
    }
    return false;
  };

  constructor(http: HttpClient, private commons:CommonsService) {
    super(http);
  }

  ngOnInit() {
    this.get().subscribe(data =>{
      this.licenseInfo = data;
      if (this.licenseInfo.custom == "" || this.licenseInfo .custom == null){
        this.licenseInfo.custom = this.commons.translate("licenseGrant.tips.noGrant")
      }
      this.spin = true
    },error1 => {
      this.spin = true;
    })
  }

}
